import http from "./http";
import { wOrgIdMiddleware } from "../utils/commonUtils";
import { CREATED, OK } from "../utils/constant";
 
const ComplaintPageServices = {
  getWorkList: wOrgIdMiddleware(async (url,visit_id) => {
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}visits/${visit_id}/worklists`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
 
  getPatientNotes: wOrgIdMiddleware(async (url,visit_id,unfinished ) => {
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}visits/${visit_id}/patientNotes?unfinished=${unfinished}`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
  
  getFamilyHistory: wOrgIdMiddleware(async (url,visit_id) => {
    try {
      const response = await http.GET(`${url}visits/${visit_id}/complaints/Family History
`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
  getAllergies: wOrgIdMiddleware(async (url,visit_id) => {
    try {
      const response = await http.GET(`${url}visits/${visit_id}/complaints/Allergies
`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
  getMedications: wOrgIdMiddleware(async (url,visit_id) => {
    try {
      const response = await http.GET(`${url}visits/${visit_id}/complaints/Medications
`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
  getProblems: wOrgIdMiddleware(async (url,visit_id) => {
    try {
      const response = await http.GET(`${url}visits/${visit_id}/complaints/Problems
`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
  getVitals: wOrgIdMiddleware(async (url,visit_id) => {
    try {
      const response = await http.GET(`${url}visits/${visit_id}/complaints/Vitals
`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
  getWorkListById: wOrgIdMiddleware(async (url, notes_id) => {
    console.log("notes_id", notes_id);
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}worklists/${notes_id}`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
 
  getPatientNotesById: wOrgIdMiddleware(async (url, worklist_id) => {
    console.log("worklist_id", worklist_id);
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}patientNotes/${worklist_id}`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
  createWorkList: wOrgIdMiddleware(async (url, payload) => {
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.POST(`${url}worklists`,payload);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
 
  createPatientNotes: wOrgIdMiddleware(async (url, payload) => {
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.POST(`${url}patientNotes`,payload);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
  updateWorkList: wOrgIdMiddleware(async (url, id,payload) => {
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.PUT(`${url}worklists/${id}`,payload);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
 
  updatePatientNotes: wOrgIdMiddleware(async (url, id ,payload) => {
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.PUT(`${url}patientNotes/${id}`,payload);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
  deleteWorkList: wOrgIdMiddleware(async (url, notes_id) => {
    console.log("notes_id", notes_id);
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.DELETE(`${url}worklists/${notes_id}`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
 
  deletePatientNotes: wOrgIdMiddleware(async (url, worklist_id) => {
    // console.log("worklist_id", worklist_id);
    // const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.DELETE(`${url}patientNotes/${worklist_id}`);
      return response;
    } catch (error) {
      console.error("Error fetching Clinic:", error);
    }
  }),
 
};
 
export default ComplaintPageServices;